import React, { useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import { Fieldset } from "primereact/fieldset";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { classNames } from "primereact/utils";
import * as Yup from "yup";
import { Dropdown } from "primereact/dropdown";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import { appConstantes } from "../../constantes/appConstantes";
import useFullPageLoader from "react-comun-seps/lib/components/FullPageLoaderHooks/useFullPageLoader";
import { useDispatch, useSelector } from "react-redux";
import RenderToast from "../../componentes/RenderToast";
import { JASPER_ROOT } from "node-constantes-seps";
import {
  obtenerEstadoJuridico,
  setEstadoJuridico,
  setMessageError,
} from "../../sliceRedux/Catastro.slice";

const Catastro = () => {
  const toast = useRef(null);
  const dispatch = useDispatch();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const messageError = useSelector((state) => state.catastro.messageError);
  const listaEstadosJuridico = useSelector((state) => state.catastro.listaEstadosJuridico);

  useEffect(() => {
    showLoader();
    dispatch(obtenerEstadoJuridico());
  }, []);

  useEffect(() => {
    if (listaEstadosJuridico.code === 200) {
      hideLoader();
    }
    return () => {
      dispatch(setEstadoJuridico({ ...listaEstadosJuridico, ...{ code: 0 } }));
    };
  }, [listaEstadosJuridico.code]);

  const validationSchema = Yup.object().shape({
    estado: Yup.string().required("Campo requerido."),
  });

  const formik = useFormik({
    initialValues: {
      estado: "",
      validado: false,
    },
    validationSchema: validationSchema,
    onSubmit: (data) => {
      window.location =
        `${JASPER_ROOT}Reports/SICCA/rptGuiaOrganizaciones.xls?j_username=visor_reportes&j_password=visor_reportes&P_ESTADO=` +
        data.estado;
    },
  });

  useEffect(() => {
    if (messageError != "") {
      RenderToast(toast, "error", "Error", messageError);
    }
    return () => {
      hideLoader();
      dispatch(setMessageError(""));
    };
  }, [messageError]);

  const getFormErrorMessage = (name) => {
    return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
  };

  const isFormFieldValid = (name) => {
    const isValid = !!(formik.touched[name] && formik.errors[name]);
    return isValid;
  };

  const handleCaptchaVerify = () => {
    formik.setFieldValue("validado", true);
  };

  return (
    <>
      {loader}
      <Toast ref={toast} />
      <div className="card">
        <Fieldset
          legend="Catastro de cajas comunales y cajas de ahorro"
          className="fieldset-catastro"
        >
          <form className="flex flex-column align-items-center w-100" style={{ margin: "0 auto" }}>
            <div className="flex align-items-center col-12 md:col-5 ">
              <label
                htmlFor="tipoIdentificacion"
                className="mr-2"
                style={{ minWidth: "180px", textAlign: "left" }}
                required
              >
                Estado jurídico:
              </label>
              <Dropdown
                id="estado"
                name="estado"
                optionLabel="nomCatalogo"
                optionValue="nomNemonico"
                placeholder="Seleccione el estado jurídico"
                options={listaEstadosJuridico?.object || []}
                value={formik.values.estado}
                emptyMessage={appConstantes.SIN_DATOS}
                className={classNames({
                  "p-invalid": isFormFieldValid("estado"),
                })}
                onChange={formik.handleChange}
                style={{ width: "100%" }}
              />
            </div>
            {getFormErrorMessage("estado")}
            <HCaptcha
              sitekey="79ff2a71-b636-4833-af19-d53fd93eff78"
              onVerify={handleCaptchaVerify}
            />
            <Button
              label="Descargar catastro de cajas comunales y cajas de ahorro"
              icon="pi pi-download"
              iconPos="right"
              type="button"
              visible={formik.values.validado}
              link
              onClick={formik.handleSubmit}
              className="mt-3"
            />
          </form>
        </Fieldset>
      </div>
    </>
  );
};
export default Catastro;
